import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './style.scss';

export const TopPanel = ({ children, customClass }) => (
    <section className={classNames('top-panel-wrap', customClass)}>
        <div className="top-panel">
            {children}
        </div>
    </section>
);

TopPanel.propTypes = {
    customClass: PropTypes.string,
    children: PropTypes.node.isRequired
};

export default TopPanel;
